"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

require("./Button.css");

var _GTMOverlay = _interopRequireDefault(require("../shared/elements/GTMOverlay"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Button = function Button(_ref) {
  var copy = _ref.copy,
      icon = _ref.icon,
      style = _ref.style,
      url = _ref.url,
      action = _ref.action,
      id = _ref.id,
      disabled = _ref.disabled;
  // TODO: refactor this to not use style keyword for prop
  var classes = "evdy-button ".concat(style);

  var ButtonBody = function ButtonBody() {
    if (!copy && !icon) return null;
    return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, icon && /*#__PURE__*/_react.default.createElement("img", {
      alt: "",
      src: icon
    }), copy && /*#__PURE__*/_react.default.createElement("span", null, copy));
  };

  return url ? /*#__PURE__*/_react.default.createElement("a", {
    className: classes,
    href: url,
    rel: "noopener noreferrer",
    target: "_blank"
  }, id && /*#__PURE__*/_react.default.createElement(_GTMOverlay.default, {
    id: id
  }), /*#__PURE__*/_react.default.createElement(ButtonBody, null)) : /*#__PURE__*/_react.default.createElement("button", {
    disabled: disabled,
    className: classes,
    onClick: action
  }, id && /*#__PURE__*/_react.default.createElement(_GTMOverlay.default, {
    id: id
  }), /*#__PURE__*/_react.default.createElement(ButtonBody, null));
};

var _default = Button;
exports.default = _default;